/**
 * @description Hook utilizado para manipular o exame de Identificação Cadaveríca
 * @author Diego Sabino Amorim de Araújo
 * @file useExameIdentificacaoCadavericaService.js
 * @license Copyright (c) 2023 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useExameIdentificacaoCadavericaService = () => {
  const fetch = useFetch()

  const listarExameIdentificacaoCadavericaAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`exameIdentificacaoCadaverica/${id}`)
      return response.data.exameIdentificacaoCadaverica
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const editarExameIdentificacaoCadaverica = async (id, values, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      await fetch.putOpen(`exameIdentificacaoCadaverica/${id}`, values)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return { listarExameIdentificacaoCadavericaAsync, editarExameIdentificacaoCadaverica }
}
